import TemplateView from "../../../TemplateView";
import UserTime from "../../../user_time";
import _ from "underscore";

export  default class SummaryRecord extends TemplateView {
    constructor($containerEl, label, containsOtherUsersEntity) {
        super($containerEl);
        this.label = label;
        this.containsOtherUsersEntity = containsOtherUsersEntity;
    }

    templateHtml() {
        return "<div class='summaryRecord'><span class='label ellipsis'><%-label%> </span><span class='value'/></div>";
    }

    shouldUpdateOnInit() {
        return false;
    }

    templateModel() {
        return {label: this.label}
    }

    afterRender() {
        this.value = null;
        this.$value = this.find('.value');
    }

    setValue(value) {
        this.value = value;
        this.update();
    }

    update() {
        if (!_.isNull(this.value))
            this.$value.text('  ' + UserTime.formatTimeWithDigitSeparator(this.value));
        this.$el.toggleClass('otherUsersEntity', this.containsOtherUsersEntity);
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/SummaryRecord.js